/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createGetPromptVersionsService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';

export default createGetPromptVersionsService({
  eventName: constants.GET_PROMPT_VERSIONS,
  statusKey: 'getPromptVersionsStatus',
  storeName: 'studioPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_VERSIONS,
  errorEvent: constants.GET_PROMPT_VERSIONS_ERROR
});
